/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_Guided_DescInputs */

const en_mk_nav_guided_desc = /** @type {(inputs: Mk_Nav_Guided_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get a review and hands-on guidance.`)
};

const id_mk_nav_guided_desc = /** @type {(inputs: Mk_Nav_Guided_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan tinjauan dan pendampingan.`)
};

/**
* | output |
* | --- |
* | "Get a review and hands-on guidance." |
*
* @param {Mk_Nav_Guided_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_guided_desc = /** @type {((inputs?: Mk_Nav_Guided_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_Guided_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_guided_desc(inputs)
	return en_mk_nav_guided_desc(inputs)
});